import {
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  ProTable,
  type ActionType,
  type ProColumns,
} from "@ant-design/pro-components";
import { Button, Popconfirm, Space } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

interface TermsCondition {
  id: string;
  term: string;
  condition: string;
  description: string;
}

// Dummy data
const dummyData: TermsCondition[] = [
  {
    id: "1",
    term: "Payment Terms",
    condition: "Net 30 Days",
    description: "Invoices are due within 30 days of issue date.",
  },
  {
    id: "2",
    term: "Warranty",
    condition: "12 Months",
    description: "Covers parts and labor for manufacturing defects only.",
  },
  {
    id: "3",
    term: "Cancellation Policy",
    condition: "48 Hours Notice",
    description: "Cancellations must be made at least 48 hours in advance.",
  },
];

const TermsConditionsTable: React.FC = () => {
  const actionRef = useRef<ActionType>();
  const [tableData, setTableData] = useState<TermsCondition[]>(dummyData);
  const navigate = useNavigate();

  const handleDelete = (id: string) => {
    setTableData((prev) => prev.filter((item) => item.id !== id));
  };

  const columns: ProColumns<TermsCondition>[] = [
    {
      title: "Terms",
      dataIndex: "term",
      key: "term",
    },
    {
      title: "Conditions",
      dataIndex: "condition",
      key: "condition",
    },
    {
      title: "Descriptions",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => navigate(`/modules/clients/terms/edit/${record.id}`)}
          />
          <Popconfirm
            title="Are you sure to delete this item?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <ProTable<TermsCondition>
        headerTitle="Terms & Conditions"
        actionRef={actionRef}
        rowKey="id"
        columns={columns}
        dataSource={tableData}
        search={false}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: true,
        }}
      />
    </div>
  );
};

export default TermsConditionsTable;
